import styles from './BindPhoneDialog.module.less'
import { ComponentFactory } from '@/mobxTools'
import BindPhoneDialogVm from './BindPhoneDialogVm'
import { commonUtils } from '@/helpers/commonUtils'
import { Button, Drawer, Input, Modal } from 'antd'
import { Z_INDEX_MAX } from '@/helpers/commonConsts'

export type BindPhoneDialogProps = {
  open: boolean
  onClose?: (open: boolean) => void
}

const BindPhoneDialog = ComponentFactory.createComponent(
  'BindPhoneDialog',
  BindPhoneDialogVm,
  (vm) => {
    const { open, onClose } = vm.props
    const isMobile = commonUtils.getIsMobile()

    return isMobile ? (
      <Drawer
        title={null}
        open={open}
        className={styles.bindPhoneDrawer}
        onClose={() => onClose?.(false)}
        placement='bottom'
        getContainer={false}
        closable={false}
        height='auto'
      >
        <div className={styles.bindPhoneDialog}>
          <div className={styles.bindPhoneDialogTitle}>请输入小鹅通登录手机号:</div>
          <Input
            value={vm.phoneNumber}
            autoComplete='off'
            placeholder='请输入小鹅通登录手机号'
            maxLength={11}
            onChange={(e) => (vm.phoneNumber = e.target.value.replace(/\D/g, ''))}
          />
          <div className={styles.drawerButtonGroup}>
            <Button block onClick={() => onClose?.(false)}>
              取消
            </Button>
            <Button type='primary' block onClick={() => vm.bindPhone()}>
              绑定
            </Button>
          </div>
        </div>
      </Drawer>
    ) : (
      <Modal
        zIndex={Z_INDEX_MAX}
        maskClosable={false}
        open={open}
        centered
        footer={false}
        width='400px'
        getContainer={false}
        onCancel={() => onClose?.(false)}
      >
        <div className={styles.bindPhoneDialog}>
          <div className={styles.bindPhoneDialogTitle}>绑定手机号</div>
          <Input
            value={vm.phoneNumber}
            autoComplete='off'
            placeholder='请输入小鹅通登录手机号'
            maxLength={11}
            onChange={(e) => (vm.phoneNumber = e.target.value.replace(/\D/g, ''))}
          />
          <div className={styles.buttonGroup}>
            <Button onClick={() => onClose?.(false)}>取消</Button>
            <Button type='primary' onClick={() => vm.bindPhone()}>
              绑定
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
)

export default BindPhoneDialog
